import { type FontScaleTypes, fontScale } from '@theme';

const streamlineFontSizeTypes = ['mini', 'small', 'medium', 'large'] as const;

export type StreamlineFontSizeType = (typeof streamlineFontSizeTypes)[number];

const sizeMap = new Map<StreamlineFontSizeType | 'default', FontScaleTypes>([
  ['mini', '-2'],
  ['small', '-1'],
  ['medium', 1],
  ['large', 3],
  ['default', 0],
]);

export const streamlineFontSizes = (size?: StreamlineFontSizeType) =>
  `${fontScale[sizeMap.get(size || 'default') || '0']}rem`;
